import type { GeolocationInput } from "@crewledger/shared/schemas";

/** Capture browser geolocation once — only call on submit/clock actions. */
export async function captureGeolocation(): Promise<GeolocationInput | null> {
  if (typeof navigator === "undefined" || !navigator.geolocation) {
    return null;
  }

  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracyMeters: position.coords.accuracy,
        });
      },
      () => resolve(null),
      { enableHighAccuracy: true, timeout: 12_000, maximumAge: 0 },
    );
  });
}

export function deviceInfoSummary(): string {
  if (typeof navigator === "undefined") return "unknown";
  return [navigator.userAgent?.slice(0, 200), navigator.platform].filter(Boolean).join(" | ");
}
